import React from "react";
import I18n from "../../../i18n";
import { Card } from "antd";
import { Metrics } from "../../../theme/";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import DataPercentList from "../../list/DataPercentList";
import { GraphDataMaker } from "../../../util/helper/graph";
import { MathUtil, isFunction } from "../../../util";
import OrgUtil from "../../../util/organize";
import { OHeader } from "../../text/OText";
import { getSplitRatio } from "../generics";
import { GRAPH } from "../../../constants/limit";

const ProgressChart = ({
	header = I18n.t("session_by.topic"),
	data, previousData,
	height=GRAPH.HEIGHT, 
	colorType,
	style, 
	showSize = 3,
	showLegend = true, 
	showColor = true,
	isLoadMore = true,
	isVertical = false,
	sort = true,
	showValue = true,
	short,
	onClick,
	onHeaderClick,
})=>{
	return (<GraphCard 
		style={{...style, marginTop:Metrics.button.spaceMargin}} 
		header={header}
		onHeaderClick={onHeaderClick}
		height={height}
		isVertical = {isVertical}
		chartWidthRatio={getSplitRatio(short)}
		fullLegendOnVertical={false}
		graph={
			<Chart.ProgressReturningBar 
				header = {header}
				showHeader={false}
				showSize = {showSize}
				data = {data}
				style = {style}
				sort = {sort}
				colorType = {colorType}
				onClick={onClick}
				showSize={showSize}
			/>
		}
		// legend={showLegend ? 
		//     <DataPercentList 
		//         percentDatas={GraphDataMaker.makeRenderDataOfObject(data, k=>k, (k,o)=>o.count)}
		//         compareDatas={previousData ? 
		//             GraphDataMaker.makeRenderDataOfObject(previousData, k=>k, (k,o)=>o.count) 
		//             : undefined}
		//         textKey='item' valueKey='count'
		//         percentKey='percent'
		//         visualColorKey={colorType}
		//         showColor={false}
		//         showValue={showValue}
		//     /> : undefined
		// } 
	/>
	);
};
export const ProgressChartInner = (props)=>{
	const { header } = props;
	return <Chart.ProgressReturningBar 
		{...props}
		value = {{title:header}}
	/>;
};
export default ProgressChart;


// WEBPACK FOOTER //
// ./src/components/report/counseling/CounselingProgressChart.js